import { ArrowLeft } from 'lucide-react'
import { cn } from '../../utils/cn'

// Barra superior fixa dos playbooks Working Backwards. Defaults = tema Nex2AI;
// o playbook Omnicore passa barClass/logo/logoAlt do playbookThemes.js.
export default function PlaybookTopBar({
  onBack,
  barClass = 'bg-gradient-to-b from-[#99020E] to-[#330105]',
  logo = '../assets/backwards/nex2ai-logo.svg',
  logoAlt = 'nex2ai',
  logoClass = 'h-6',
}) {
  const handleBack = () => {
    if (onBack) {
      onBack()
      return
    }
    window.history.back()
  }

  return (
    // fundo full-bleed; conteúdo centrado na composição de 1440px do design
    <div className={cn('w-full', barClass)}>
      <div className="mx-auto flex h-20 w-full max-w-[1440px] items-center justify-between px-20">
        <button
          type="button"
          onClick={handleBack}
          aria-label="Voltar"
          className="flex h-8 w-8 items-center justify-center text-white"
        >
          <ArrowLeft size={32} strokeWidth={2} />
        </button>
        <img src={logo} alt={logoAlt} className={logoClass} />
      </div>
    </div>
  )
}
